<template>
  <form @submit.prevent="saveForm()">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head flex justify-between">
        <p class="modal-card-title">
          Create Notification
        </p>
      </header>
      <section class="modal-card-body">
        <d-field label="Subject*">
          <d-input v-model="notificationForm.subject" :required="true" />
        </d-field>

        <div v-if="type == 'group'">
          <d-field label="Filter Recipients By Role (optional)">
            <d-select v-model="notificationForm.role" placeholder="Select role (optional)">
              <option value="Mentor">
                Mentors
              </option>
              <option value="Mentee">
                Mentees
              </option>
            </d-select>
          </d-field>
          <div class="mb-5">
            Use this option to only send notifications to the selected role within the group if desired
          </div>
        </div>

        <d-field label="Notification Content*">
          <vue-editor v-model="notificationForm.htmlContent" :required="true" :editor-toolbar="customToolbar" />
        </d-field>

        <div>
          <input type="file" multiple ref="fileInput" style="display: none" @change="handleFileUpload">
          <d-btn type="button" flat @click="openFileInput">
            Attach File
          </d-btn>
        </div>

        <div class="flex grow grow-1 flex-wrap gap-x-4 gap-y-2 mt-2">
          <div v-for="attachment in notificationForm.attachments" :key="attachment.uploadName" class="flex items-center p-2 bg-light-gray border rounded"
            style="height:32px">
            <span class="text-sm text-truncate">
              {{ attachment.displayName }}
            </span>

            <d-icon icon="trash" class="cursor-pointer text-red ml-2 py-2 bg-transparent" @click="removeAttachment(attachment)" />
          </div>
        </div>

      </section>
      <footer class="modal-card-foot justify-end">
        <d-btn flat @click="$parent.close()">
          Cancel
        </d-btn>
        <d-btn :loading="uploading || saving" type="submit">
          Send
        </d-btn>
      </footer>
    </div>
  </form>
</template>
<script>
import axios from 'axios';

export default {
  props: {
    entityId: {
      type: [String, Number],
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    uploading: false,
    saving: false,
    notificationForm: {
      subject: '',
      htmlContent: '',
      userId: null,
      groupId: null,
      sendEmail: true,
      role: '',
      attachments: [],
      attachmentUrls: [],
    },
    customToolbar: [
      [{ header: [false, 3, 4, 5, 6] }], ['bold', 'italic', 'underline', 'strike'],
      [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
      [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }], ['blockquote', 'code-block'],
      [{ indent: '-1' }, { indent: '+1' }], [{ color: [] }, { background: [] }], ['clean'],
    ],
  }),
  mounted() {
    if (this.type === 'group') {
      this.notificationForm.groupId = this.entityId;
    } else {
      this.notificationForm.userId = this.entityId;
    }
  },
  methods: {
    async saveForm() {
      this.saving = true;
      try {
        this.notificationForm.attachmentUrls = this.notificationForm.attachments?.map(p => p.url);

        await axios.post('/api/notifications', this.notificationForm);
        await this.$parent.events.getNotificationsPaged();
        this.$parent.close();
      } catch (error) {
        this.$toast.open({ message: error.response, color: 'red-500', duration: 4000 });
      } finally {
        this.saving = false;
      }
    },

    openFileInput() {
      this.$refs.fileInput.click();
    },

    async handleFileUpload(event) {
      if (!event.target.files.length) {
        return;
      }

      if (event.target.files.length > 3 || event.target.files.length + this.notificationForm.attachments.length > 3) {
        this.$toast.open({ message: 'File uploading is limited to 3 files. If you need to upload more, upload as a zipped file.', color: 'red-500', duration: 4000 });
        return;
      }

      this.uploading = true;

      const files = [];
      for (let i = 0; i < event.target.files.length; i++) {
        const file = event.target.files[i];
        files.push(file);
      }

      const form = new FormData();
      files.forEach(file => form.append('File', file));

      try {
        const { data: uploadedAttachments } = await axios.post('/api/uploads', form);
        uploadedAttachments.forEach(attachment => this.notificationForm.attachments.push(attachment));
      } catch (error) {
        this.$toast.open({ message: error.response, color: 'red-500', duration: 4000 });
      } finally {
        this.uploading = false;
      }
    },

    async removeAttachment(attachment) {
      this.notificationForm.attachments = this.notificationForm.attachments.filter(p => p !== attachment);
      await axios.delete(`/api/uploads`, {
        params: {
          url: attachment.url
        }
      });
    }
  },
};
</script>